import { render, staticRenderFns } from "./SpatialSpanWorkingMemory.vue?vue&type=template&id=e9bc396c&scoped=true&"
import script from "./SpatialSpanWorkingMemory.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanWorkingMemory.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanWorkingMemory.vue?vue&type=style&index=0&id=e9bc396c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bc396c",
  null
  
)

export default component.exports